import styled from "styled-components";

const TRANSITION_DURATION = "300ms";
const TRANSITION_TIMING_FUNCTION = "ease-in-out";

export const StyledRadioButtonInput = styled.input`
	border-radius: 50%;

	:checked + .RadioButton__circle {
		::before {
			opacity: 1;
		}
	}
`;

export const StyledRadioButtonCircle = styled.span`
	border-radius: 50%;

	::before {
		content: "";
		display: block;
		opacity: 0;
		position: relative;
		width: 8px;
		height: 8px;
		border-radius: 50%;
		transition: opacity ${TRANSITION_DURATION} ${TRANSITION_TIMING_FUNCTION};
		background-color: ${({ theme }) => theme.palette.hexForRole("bg_white")};
	}

	:hover {
		::before {
			opacity: 1;
		}
	}
`;
